module.exports = __webpack_public_path__ + "static/media/2.37a62d19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-signup-works/2.jpg
// module id = 391
// module chunks = 0